import { Dropdown } from "@fluentui/react/lib/Dropdown";
import { useState } from "react";
import { useParams } from "react-router-dom";
import contacts from "../../constants/contacts";
import faqContent from "../../constants/faq";
import { getUserLang, isNullOrEmpty } from "../../lib/helper";
import { useInjectedService } from "../../services/ioc/service-dependency";

import "./faq.css";

const FAQ = (props: { pathname: string }) => {
  const [selectedLocation, setSelectedLocation] = useState<string | undefined>(
    ""
  );

  const expandAccordionItem = (index: number) => {
    var accordionItem = document.querySelectorAll(
      ".bbraun-accordion-item:nth-child(" + index + ")"
    );
    if (accordionItem.length > 0) {
      if (accordionItem[0].classList.contains("is-expanded")) {
        accordionItem[0].classList.remove("is-expanded");
      } else {
        accordionItem[0].classList.add("is-expanded");
      }
    }
  };

  const { localizationService } = useInjectedService();

  let { culture } = useParams();
  let defaultCulture = getUserLang(props.pathname);
  if (
    !isNullOrEmpty(culture) &&
    culture !== undefined &&
    localizationService.isValidCulture(culture, props.pathname)
  ) {
    defaultCulture = culture;
  }

  const contactOptions = contacts.sort(function (a, b) {
    if (a.country < b.country) return -1;
    if (a.country > b.country) return 1;
    return 0;
  });

  return (
    <div>
      <div className="row bbraun-faq-row">
        <div className="col-sm">
          <div className="bbraun-hero">
            <div className="bbraun-hero-headline">
              {localizationService.getLocalizedText("Contact")}
            </div>
            <div className="bbraun-hero-content">
              <span className="material-icons">handshake</span>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-sm">
          <Dropdown
            className="bbraun-contact-dropdown"
            selectedKey={selectedLocation}
            onChange={(e, c) => setSelectedLocation(c?.key.toString())}
            placeholder={localizationService.getLocalizedText("selectRegion")}
            options={contactOptions.map((c) => {
              return { key: c.countryCode, text: c.country };
            })}
          />
        </div>
      </div>
      {!isNullOrEmpty(selectedLocation) && (
        <div className="row">
          <div className="col-sm">
            <table className="bbraun-contact-table" border={1}>
              <tbody>
                {contactOptions
                  .filter((c) => c.countryCode === selectedLocation)
                  .map((selectedContact) => {
                    return (
                      <tr>
                        <td>{selectedContact.country}</td>
                        <td>
                          {selectedContact.phoneNumbers.map((p) => {
                            return (
                              <>
                                {p}
                                <br />
                              </>
                            );
                          })}
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
        </div>
      )}
      <div className="row bbraun-faq-row">
        <div className="col-sm">
          <div className="bbraun-hero">
            <div className="bbraun-hero-headline">
              {localizationService.getLocalizedText("FAQ")}
            </div>
            <div className="bbraun-hero-content">
              <span className="material-icons">help_outline</span>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-sm">
          <div className="bbraun-accordion">
            {faqContent
              .filter(
                (f) =>
                  f.languages.filter((l) => l === defaultCulture).length > 0
              )
              .map((faq, index) => {
                return (
                  <div className="bbraun-accordion-item">
                    <h3 className="bbraun-accordion-item-header">
                      <button onClick={() => expandAccordionItem(index + 1)}>
                        <span
                          className="bbraun-accordion-item-header-text"
                          dangerouslySetInnerHTML={{ __html: faq.question }}
                        />
                        <span className="bbraun-accordion-item-header-icon material-icons">
                          expand_more
                        </span>
                      </button>
                    </h3>
                    <div className="bbraun-accordion-item-content">
                      <div
                        dangerouslySetInnerHTML={{
                          __html: faq.answer.replace(
                            /{window.location.origin}/g,
                            window.location.origin
                          ),
                        }}
                      />
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQ;
